import { useEffect, useState } from 'react'
import { Box, Grid, useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import {
  Loader,
  MobileBottomLayout,
  PaginationButtons,
  PaginationContext,
  TotalCount,
} from 'src/components'
import { Filter } from '../filter'
import { TableView } from './table-view'

import { useFilter, usePagination, useUsers } from 'src/hooks'
import { useUserListSelectionOptions } from './use-user-list-selection-options.hook'
import { useSusepnedListSelectionOptions } from './use-suspended-list-selection-optoins.hook'
import { useSuperuserListSelectionOptions } from './use-superuser.hook'
import { useTwoFaListSelectionOptions } from './use-2fa.hook'
import { useAccountSelectionOptions } from './use-account-selection-options.hook'

import { countOffset, sortToObject } from 'src/common/utils'
import { defaultLimit, defaultPage } from 'src/constants'
import { ETranslationNs } from 'src/types'

const UsersList = () => {
  const [t] = useTranslation(ETranslationNs.Users)

  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const [filter, setFilter] = useFilter({
    initialState: {
      query: '',
      white_label: ['all'],
      suspended: ['all'],
      superuser: ['all'],
      twofa: ['all'],
      account: ['all'],
    },
  })
  const { page, setPage, rowsPerPage, setRowsPerPage } = usePagination(defaultPage, defaultLimit)

  const [sort, setSort] = useState('created_at-desc')
  const usersFilter = { ...filter, ...sortToObject(sort) }
  const { data: users, isLoading } = useUsers({
    ...usersFilter,
    offset: countOffset(page, rowsPerPage),
    limit: rowsPerPage,
  })

  useEffect(() => {
    setPage(defaultPage)
  }, [filter, setPage, sort])
  // const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))

  // const [layoutFormat, setLayoutFormat] = useState<LayoutFormat>(
  //   isLaptop ? LayoutFormat.Grid : LayoutFormat.Table,
  // )

  // const handleLayoutChange = () => setLayoutFormat(layoutFormat > 0 ? 0 : 1)
  const allUsersSelection = useUserListSelectionOptions()
  const allSuspention = useSusepnedListSelectionOptions()
  const allSperUsers = useSuperuserListSelectionOptions()
  const allTwoFa = useTwoFaListSelectionOptions()
  const haveAccountsSelection = useAccountSelectionOptions()

  const paginationValues = {
    count: users?.count ?? 0,
    page: page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    isShown: !!users && users.count > rowsPerPage,
  }

  return (
    <Grid container>
      <>
        <Filter
          searchFieldText={t('users-search-input.v')}
          filter={filter}
          setFilter={setFilter}
          sort={sort}
          setSort={setSort}
          selectionOptions={[
            { ...allUsersSelection, withSearch: true },
            { ...allSuspention },
            { ...allSperUsers },
            { ...allTwoFa },
            haveAccountsSelection,
          ]}
          initialState={{
            query: '',
            white_label: ['all'],
            suspended: ['all'],
            superuser: ['all'],
            twofa: ['all'],
            account: ['all'],
          }}
        />
        {users && <TotalCount count={users.count} />}

        {isLoading && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              m: '30px',
            }}
          >
            <Loader isStatic />
          </Box>
        )}

        {/* <LayoutButtons layoutFormat={layoutFormat} handleLayoutChange={handleLayoutChange} /> */}

        <PaginationContext.Provider value={paginationValues}>
          {!isLoading && (
            <TableView sort={sort} setSort={setSort} filter={usersFilter} data={users?.data} />
          )}
          {!isTablet && !isLoading && <PaginationButtons />}
          {isTablet && !isLoading && (
            <MobileBottomLayout>
              <PaginationButtons buttonsOnly />
            </MobileBottomLayout>
          )}
        </PaginationContext.Provider>
      </>
    </Grid>
  )
}

export { UsersList }
